import axiosInstance from "./axiosInstance";

export const getTruckByPlantId = async (plantId) => {
  return await axiosInstance.get(`/truckDriverByPlant/${plantId}`);
};

export const getTruckDriver = async (userId) => {
  return await axiosInstance.get(`/truckDriver/${userId}`);
};

export const getTrack = async (driver_id, stock_id, trip_id) => {
  return await axiosInstance.get(`/track/${driver_id}/${stock_id}/${trip_id}`);
};

export const getLocations = async (driver_id, stock_id, trip_id) => {
  return await axiosInstance.get(
    `/locations/${driver_id}/${stock_id}/${trip_id}`
  );
};


